import { ApplicationType } from '@sdir/httpclient/lib/clients/aps/application';
import {
  CertificateV2,
  CertificateStatus,
  PersonalCertificateResultV2,
  LanguageComponent,
} from '@sdir/httpclient/lib/clients/aps/personalcertificate';
import { IntlShape } from 'react-intl';
import { GenericTileStatus, SimplifiedApplicationStatus } from '../types';

export const showCertificateAsExpired = (certificate: PersonalCertificateResultV2): boolean => {
  return certificate?.status === CertificateStatus.Expired;
};

export const filterOutExpiredCertificates = (
  certificates: PersonalCertificateResultV2[]
): PersonalCertificateResultV2[] => {
  return certificates.filter((c) => c.status !== CertificateStatus.Expired);
};

export const certificateTypeTranslationMap: { [key: string]: string } = {
  [ApplicationType.FirstTime]: 'app.type.firstTime',
  [ApplicationType.Duplicate]: 'app.type.duplicate',
  [ApplicationType.Renewal]: 'app.type.renewal',
  [ApplicationType.Upgrade]: 'app.type.upgrade',
};

export const translateCertificateType = (type: ApplicationType, intl: IntlShape): string => {
  const translationKey = certificateTypeTranslationMap[type];
  return translationKey ? intl.formatMessage({ id: translationKey }) : type;
};

export const convertApplicationStatus = (status?: SimplifiedApplicationStatus) => {
  switch (status) {
    case SimplifiedApplicationStatus.Setup:
      return GenericTileStatus.Started;
    case SimplifiedApplicationStatus.AwaitingPayment:
    case SimplifiedApplicationStatus.MoreInfoRequested:
      return GenericTileStatus.Incomplete;
    case SimplifiedApplicationStatus.Approved:
      return GenericTileStatus.Valid;
    case SimplifiedApplicationStatus.Rejected:
    case SimplifiedApplicationStatus.RejectedNotPaid:
      return GenericTileStatus.Rejected;
    default:
      return GenericTileStatus.Handling;
  }
};

export const CapitalizeString = (text: string) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const GetLocalizedCertificateName = (certificate: CertificateV2) => {
  const localizedName = certificate.name || '';
  return CapitalizeString(localizedName);
};

export const GetLocalizedStringFromLanguageComponent = (
  lang: string,
  languageComponent?: LanguageComponent
) => {
  const localized = languageComponent?.[lang] || languageComponent?.no || '';
  return CapitalizeString(localized);
};

export const GetCertificateNameByCode = (
  lang: string,
  code?: string | null,
  certificates?: CertificateV2[] | null
) => {
  if (!code || !certificates) return '';
  const certificate = certificates?.find((c) => c?.code?.toUpperCase() === code.toUpperCase());
  return certificate ? GetLocalizedCertificateName(certificate) : '';
};
